export default __webpack_public_path__ + "static/media/insights-empty-statement-grayscale.56cb91ec.svg";